import React from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { activeLink } from "../../../shared/activeLink";
import { iProductGroup } from "../store";

export const ItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;

    &.sub {
        padding-left: 15px;
    }

    & + &:not(.sub) {
        margin-top: 10px;
    }
`;

export const Item = styled.button`
    position: relative;
    cursor: pointer;
    font-weight: 500;
    font-size: 1.1em;
    width: fit-content;
    text-align: left;
    ${activeLink};

    padding: 0;

    &:hover {
        color: ${({ theme }) => theme.colors.red.toString()};
    }

    ${({ theme }) =>
        theme.breakpoints.from.medium.css`
            font-size: 1rem;
            line-height: 24px
    `}
    ${({ theme }) =>
        theme.breakpoints.from.large.css`
            font-size: 1rem;
    `}


    color: ${({ theme }) => theme.colors.blue.toString()};
    border-top: none;
    border-left: none;
    border-right: none;
    background-color: inherit;
`;

type iSubItem = {
    isActive: boolean;
};
export const SubItem = styled.button<iSubItem>`
    color: ${({ theme }) => theme.colors.red.toString()};
    border: none;
    background-color: inherit;
    position: relative;
    cursor: pointer;
    font-size: 1.1em;
    width: fit-content;
    text-align: left;
    padding: 0;

    ${({ theme }) =>
        theme.breakpoints.from.medium.css`
            font-size: 1rem;
            line-height: 24px
    `}
    ${({ theme }) =>
        theme.breakpoints.from.large.css`
            font-size: 1rem;
    `}
    &:hover {
        text-decoration: underline;
    }

    ${({ isActive }) =>
        isActive &&
        css`
            text-decoration: underline;
        `}
`;

interface Props {
    productGroup: iProductGroup;
    selectedProductTree: number[];
    selectGroup: (group: iProductGroup) => void;
    isSub?: boolean;
}

const GroupTreeItem = ({
    productGroup,
    selectedProductTree,
    selectGroup,
    isSub = false,
}: Props) => {
    const ItemElement = isSub ? SubItem : Item;
    const isSelected = selectedProductTree.includes(productGroup.id);
    return (
        <ItemContainer className={isSub ? "sub" : ""}>
            <ItemElement
                isActive={isSelected}
                onClick={() => {
                    selectGroup(productGroup);
                }}
                className={isSelected ? "active" : ""}
            >
                {productGroup.displayName}
            </ItemElement>

            {isSelected &&
                productGroup.children &&
                productGroup.children.map((group) => (
                    <GroupTreeItem
                        key={group.id}
                        isSub={true}
                        selectGroup={selectGroup}
                        productGroup={group}
                        selectedProductTree={selectedProductTree}
                    />
                ))}
        </ItemContainer>
    );
};

export default GroupTreeItem;
